import gql from 'graphql-tag'

// eslint-disable-next-line import/prefer-default-export
export const GET_MONERIUM_AUTH_TOKEN = gql`
  query getMoneriumAuthToken {
    getMoneriumAuthToken
  }
`;
